import { Button } from "@/components/ui/button";
import AssistantLogo from "@/components/vistassistant/AssistantLogo";
import assistantStore, { openAssistant } from "@/stores/assistantStore";
import { useSelector } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";

/**
 * Opens the assistant again, on every page, while it is closed: the panel comes back with its
 * conversation as it was (nothing is sent). An answer that arrived while it was closed shows as a
 * pink dot on the logo, as in the list.
 */
const AssistantButton = () => {
    const { t } = useTranslation();
    const unreadAnswer = useSelector(assistantStore, (s) => s.unreadAnswer);
    const label = t(
        unreadAnswer
            ? "vistassistant.openAssistantUnread"
            : "vistassistant.openAssistant",
    );

    return (
        <Button
            aria-label={label}
            className="[&_svg]:size-6"
            gradientBorderVariant="lavenderGradient"
            icon={
                <span className="relative flex">
                    <AssistantLogo size="xs" />
                    {unreadAnswer && (
                        <span
                            aria-hidden
                            className="absolute -right-0.5 -top-0.5 size-2.5 rounded-full border-2 border-white bg-primary-pink"
                        />
                    )}
                </span>
            }
            onClick={() => openAssistant()}
            size="gradient"
            title={label}
            variant="lavenderGradient"
        >
            <span className="hidden text-assistant-ink md:inline">
                {t("vistassistant.title")}
            </span>
        </Button>
    );
};

export default AssistantButton;
